import template from "./pUser.html";
import moment from "moment";
import * as configs from './configs.js';

export function pUserDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pUserController,
    controllerAs: 'pUser',
    bindToController: true
  };

  return directive;
}

class pUserController {
  constructor(Auth, Admin, $routeParams, $q, $translate, $scope, $interval, Notes, Language, $filter, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.$translate = $translate;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.language = Language.currentLanguage();
    this.listAllowedClientsId = [];
    this.init();
    this.$filter = $filter;

    this.valuesFields = configs.valuesFields;

    this.actions = configs.actions;

    this.actionsOfferCalc = configs.actionsOfferCalc;

    this.editUserData = configs.editUserData;

    this.rowActionsRestricted = configs.rowActionsRestricted;

    this.editUserOCAccessData = configs.editUserOCAccessData;

    this.positionFields = configs.positionFields;

    this.teamFields = configs.teamFields;

    this.positionWeekDays = false;

    this.fieldsToSort = {
      active: "active"
    };

    // Positions table header-cell = "Standard working hours"
    this.positionExtraColspan = {
      mon: 1
    };

    this.hiddenHeads = {
      tue: true,
      wed: true,
      thu: true,
      fri: true,
      sat: true,
      sun: true
    };

    this.positionDialogCardWeekTable = false;

    this.positionActions = configs.positionActions;

    this.positionRowActions = configs.positionRowActions;

    this.positionData = configs.positionData;

    this.rateFields = configs.rateFields;

    this.clientRestrictedFields = configs.clientRestrictedFields;

    this.subscriptionFields = configs.subscriptionFields;

    this.subscriptionActions = [
      {
        name: "new",
        functionName: "chooseSubscriptionFunc",
        fa: "fa-plus",
        tooltipOnBlocked: this.$translate.instant("SUBSCRIPTIONS.ADD_BUTTON_TOOLTIP")
      }
    ];

    this.overtimeSubscriptionActions = [
      {
        name: "new",
        functionName: "startAddingOvertimeSubscription",
        fa: "fa-plus",
        tooltipOnBlocked: this.$translate.instant("SUBSCRIPTIONS.ADD_BUTTON_TOOLTIP")
      }
    ];

    this.overtimeSubscriptionActions = [
      {
        name: "new",
        functionName: "startAddingOvertimeSubscription",
        fa: "fa-plus",
        tooltipOnBlocked: this.$translate.instant("SUBSCRIPTIONS.ADD_BUTTON_TOOLTIP")
      }
    ];

    this.subscriptionRowActions = configs.subscriptionRowActions;

    this.profitabilitySubscriptionData  = {
      ...configs.profitabilitySubscriptionData,
      currency: {
        type: "radioSection",
        isNotRequired: true,
        options: [
          {
            name: "local",
            label: this.$translate.instant("SUBSCRIPTIONS.LOCAL"),
            value: "Local"
          },
          {
            name: "eur",
            label: "EUR",
            value: "EUR"
          }
        ]
      },
      longTermReportTwelveMonths: {
        type: "radioSection",
        isNotRequired: true,
        options: [
          {
            name: "sixMonths",
            label: this.$translate.instant("SUBSCRIPTIONS.SIX_MONTHS"),
            value: false
          },
          {
            name: "twelveMonths",
            label: this.$translate.instant("SUBSCRIPTIONS.TWELVE_MONTHS"),
            value: true
          }
        ]
      }
    };

    this.teamColumnsWithThreshold = ['teamAcceptedOvertimeThreshold', 'teamReportedOvertimeThreshold', 'teamCumulatedOvertimeThreshold'];
    this.employeeColumnsWithThreshold = ['employeeAcceptedOvertimeThreshold', 'employeeReportedOvertimeThreshold', 'employeeCumulatedOvertimeThreshold'];

    this.overtimeSubscriptionData = configs.overtimeSubscriptionData;
    this.overtimeRequestsSubscriptionData = configs.overtimeRequestsAlertData;

    this.overtimeSubscriptionOrder = {
      AcceptedOvertime: 'Accepted overtime',
      AcceptedOvertimePercentage: 'Accepted overtime %',
      AcceptedWorklogPercentage: 'Accepted worklog %',
      CumulatedOvertime: 'Overtime balance',
      ReportedOvertime: 'Reported overtime'
    };

    this.subscriptionSelect = {
      sendAtMonthDay: Array.from({length: 31}, (_, i) => i + 1),
      orderBy: {
        valueToAdd: "id",
        valueToShow: "name",
        values: Object.keys(this.overtimeSubscriptionOrder).map(key => ({id: key, name: this.overtimeSubscriptionOrder[key]})),
      },
      teamRows: Array.from({length: 20}, (_, i) => (i + 1) * 5),
      employeeRows: Array.from({length: 10}, (_, i) => (i + 1) * 10)
    };

    this.subordinateTeamsFields = configs.subordinateTeamsFields;
    this.subordinateTeamsRowActions = configs.subordinateTeamsRowActions;

    this.FORM_NAME_DICTIONARY = {
      overtime: "OVERTIME_SUBSCRIPTIONS",
      profitability: "SUBSCRIPTIONS",
      overtimeRequestsAlert: "OVERTIME_REQUESTS_ALERT"
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.userAdmin = user;
        this.isLocalAdmin = this.userAdmin.isLocalAdmin;

        if(this.userAdmin.isLocalAdmin) {
          delete this.editUserData.canEditAccepted;
          delete this.editUserData.isLocalAdmin;
          delete this.editUserData.isAdmin;
          delete this.editUserData.isIntegrationAdmin;
          delete this.editUserOCAccessData.calcGlobalBidsAccess;
          delete this.editUserData.canUpdateRates;
          delete this.editUserData.canViewRates;
          delete this.editUserData.canAccess360View;
          delete this.editUserData.canAccessFlexitime;
        }

        let promises = [
          this.Admin.getUser(this.$routeParams.userId),
          this.Admin.getTeam(this.$routeParams.teamId),
          this.Admin.getCountry(this.$routeParams.name),
          this.Admin.getRestrictedClients(this.$routeParams.userId),
          this.Admin.getUserProfitabilitySubscription(this.$routeParams.userId),
          this.Admin.getUserOvertimeSubscription(this.$routeParams.userId),
          this.Admin.getUserLegalSubscription(this.$routeParams.userId),
          this.Admin.getUserSubordinateTeams(this.$routeParams.userId),
          this.Admin.getUserSubordinateTeamsOverwrites(this.$routeParams.userId),
          this.Admin.getUserOvertimeRequestSubscriptions(this.$routeParams.userId)
        ];

        this.$q.all(promises).then(
          (success) => {
            this.user = success[0].data.user;
            this.isManager = this.user.role.includes('Manager');
            this.restrictedClientAccess = success[0].data.user.restrictedClientAccess;
            this.clients = success[3].data;
            this.mailToken = success[0].data.mailToken;

            this.subscriptions = success[4].data.length ? success[4].data : [];

            if (this.subscriptions.length)
              this.subscriptions.forEach(p => {
                p.sendAt = p.sendAtMonthDay + ' ' + this.$translate.instant("SUBSCRIPTIONS.DAY");
                p.profitabilitySubscription = !p.tables.includes('Team');
                p.profitability = p.tables.includes('Profitability');
                p.duration = p.tables.includes('Duration');
                p.hourlyRate = p.tables.includes('HourlyRate');
                p.currencyName = p.currency === 'EUR' ? p.currency : this.$translate.instant("SUBSCRIPTIONS.LOCAL");
                p.longTermReportTwelveMonthsInfo = p.longTermReportTwelveMonths
                  ? this.$translate.instant("SUBSCRIPTIONS.TWELVE_MONTHS")
                  : this.$translate.instant("SUBSCRIPTIONS.SIX_MONTHS");
              });

            this.overtimeSubscriptions = success[5].data.length ? success[5].data : [];

            const thresholdToHour = (value) => {
              return value ? this.$filter("hms")(moment.duration(value).toJSON()) : null;
            };

            if (this.overtimeSubscriptions.length)
              this.overtimeSubscriptions.forEach(p => {
                p.sendAt = p.sendAtMonthDay + ' ' + this.$translate.instant("SUBSCRIPTIONS.DAY");
                p.team = p.tables.includes('Team');
                p.employee = p.tables.includes('Employee');
                p.overtimeSubscription = true;
                p.teamAcceptedOvertimeThreshold = thresholdToHour(p.teamAcceptedOvertimeThreshold);
                p.teamReportedOvertimeThreshold = thresholdToHour(p.teamReportedOvertimeThreshold);
                p.teamCumulatedOvertimeThreshold = thresholdToHour(p.teamCumulatedOvertimeThreshold);
                p.employeeAcceptedOvertimeThreshold = thresholdToHour(p.employeeAcceptedOvertimeThreshold);
                p.employeeReportedOvertimeThreshold = thresholdToHour(p.employeeReportedOvertimeThreshold);
                p.employeeCumulatedOvertimeThreshold = thresholdToHour(p.employeeCumulatedOvertimeThreshold);
                p.teamRows = p.teamRows ? p.teamRows.toString() : "10";
                p.employeeRows = p.employeeRows ? p.employeeRows.toString() : "10";
              });

            this.legalSubscriptions = success[6].data.length ? success[6].data : [];
            this.legalSubscriptions.forEach(sub => {
              sub.legalAlert = true;
              sub.sendAt = "";
            });

            const formatted = moment(this.user.blockedAt).format("YYYY-MM-DD");

            this.featureFlags = success[2].data.country.flags;
            this.subordinateTeams = success[2].data.teams
              .filter(team => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? team.id !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true)
              .map(team => ({
                ...team,
                active: success[7].data.subordinateTeams.some(subordinateTeam => subordinateTeam.id === team.id),
                main: team.id === this.user.teamId,
                overwrite: success[8].data.subordinateTeamOverwrites.find(teamOverwrites => teamOverwrites.teamId === team.id),
                archived: Boolean(team.archivedAt)
              }))
              .sort((teamA, teamB) => teamA.name.localeCompare(teamB.name))
              .sort((teamA, teamB) => teamB.main - teamA.main);
            this.is360FeatureFlag = this.featureFlags.indexOf("View360") > -1;
            this.isFlexiFeatureFlag = this.featureFlags.indexOf("Flexitime") > -1;
            this.isD365FeatureFlag = this.featureFlags.indexOf("D365Integration") > -1;

            if (!this.featureFlags.includes("D365Integration")) {
              delete this.editUserData.invoicedTime;
              delete this.editUserData.projectVisibilityFromD365;
            }

            this.overtimeRequestSubscriptions = success[9].data.length
              ? success[9].data.map(sub => ({
                ...sub,
                teamName: sub.allTeams ? 'All teams' : this.subordinateTeams.find(team => team.id === sub.teamId).name}
              ))
              : [];

            this.allSubscriptions = [...this.subscriptions, ...this.overtimeSubscriptions, ...this.legalSubscriptions, ...this.overtimeRequestSubscriptions];

            this.user.blockedAtFormatted = formatted;

            if(this.user.role === "Employee") {
              this.editUserData =
              {...this.editUserData,
                restrictedClientAccess: {
                type: "checkbox",
                isNotRequired: true,}
              };
            }

            if (this.user.role == "GlobalManager" && this.userAdmin.isLocalAdmin) {
              this.actions[0].blocked = true;
              this.actionsOfferCalc[0].blocked = true;
            }
            this.positions = success[0].data.userPositions.sort((a, b) => {
              const aValidFrom = moment(a.validFrom);
              const bValidFrom = moment(b.validFrom);
              if (aValidFrom.isAfter(bValidFrom)) {
                return -1;
              }
              if (aValidFrom.isBefore(bValidFrom)) {
                return 1;
              }

              return 0;
            }).map(p => {
              p.seniorityLevelName = this.$translate.instant(`USER.${p.seniorityLevel}`);
              return p;
            });
            this.positions.forEach((p, index, positionsArray) => {
              p.siteName = success[0].data.availableSites.find(s => s.id == p.siteId).name;

              if(moment(p.validFrom) > moment(new Date)) p.validFor = "";
              else {
                let fromDate = index === 0 ? moment(new Date) : moment( positionsArray[index-1].validFrom);
                let toDate = index === 0 ? moment(p.validFrom) : moment(p.validFrom);
                let years = 0;
                let months = 0;
                let days = 0;
                years = fromDate.diff(toDate, "y");
                months = fromDate.diff(toDate, "month");
                if(months > 11) {
                  months=months%12;
                }
                else if (months === 0 ) {
                  days = fromDate.diff(toDate, "d");
                }
                let period = years != 0 ? years + "y " : "";
                period += months != 0 ? months + "m " : "";
                period += days !== 0 ? days + "d" : "";
                p.validFor = period;
              }
            });
            this.positionsNew = angular.copy(this.positions);
            this.positionsNew.forEach(p => {
              p.mon = Math.round(parseFloat(p.worknorms[0])*100)/100;
              p.tue = Math.round(parseFloat(p.worknorms[1])*100)/100;
              p.wed = Math.round(parseFloat(p.worknorms[2])*100)/100;
              p.thu = Math.round(parseFloat(p.worknorms[3])*100)/100;
              p.fri = Math.round(parseFloat(p.worknorms[4])*100)/100;
              p.sat = Math.round(parseFloat(p.worknorms[5])*100)/100;
              p.sun = Math.round(parseFloat(p.worknorms[6])*100)/100;
            });

            this.teams = success[0].data.teamChangelog;
            this.teams && this.teams.forEach((t, i) => {
              const profitCenter = success[0].data.availableProfitCenters.find(s => s.id == t.profitCenterId);
              if(profitCenter) {
                this.teams[i].teamName = `${t.teamName} - ${profitCenter.code} - ${profitCenter.name}`;
              }
            });
            this.teams.sort( (a,b) => new Date(b.when) - new Date(a.when));

            this.clientRestrictedData = [];
            this.clients.allowedClients.map(client => {
              this.clientRestrictedData.push({clientName: client.name , isAllowed: true, id: client.id  });
              this.listAllowedClientsId.push(client.id);
            });
            this.clients.notAllowedClients.map(client => {
              this.clientRestrictedData.push({clientName: client.name , isAllowed: false, id: client.id });
            });

            this.userData = [
              {
                userLabel: this.$translate.instant("USER.FULL_NAME"),
                userValue: this.user.fullName
              },
              {
                userLabel: this.$translate.instant("USER.EMAIL_ADDRESS"),
                userValue: this.user.emailAddress
              },
              {
                userLabel: this.$translate.instant("USER.ROLE"),
                userValue: this.user.role
              },
              {
                userLabel: this.$translate.instant("USER.CAN_EDIT_ACCEPTED"),
                userValue: this.user.canEditAccepted
              },
              {
                userLabel: this.$translate.instant("USER.CAN_EXPORT_WORKLOG"),
                userValue: this.user.canExportWorklog
              },
              {
                userLabel: this.$translate.instant("USER.ACCEPT_PERSONAL_WORKLOGS"),
                userValue: this.user.acceptPersonalWorklogs
              },
              {
                userLabel: this.$translate.instant("USER.CAN_IMPORT_INCOME"),
                userValue: this.user.canImportIncome
              },
              {
                userLabel: this.$translate.instant("USER.CAN_IMPORT_INCOME_COUNTRYWIDE"),
                userValue: this.user.canImportIncomeCountrywide
              },
              {
                userLabel: this.$translate.instant("USER.CAN_VIEW_RATES"),
                userValue: this.user.canViewRates
              },
              {
                userLabel: this.$translate.instant("USER.CAN_UPDATE_RATES"),
                userValue: this.user.canUpdateRates
              },
              {
                userLabel: this.$translate.instant("USER.MANAGEMENT_VIEW_HIDDEN"),
                userValue: this.user.managementViewHidden
              },
              {
                userLabel: this.$translate.instant("USER.IS_INTEGRATION_ADMIN"),
                userValue: this.user.isIntegrationAdmin
              },
              {
                userLabel: this.$translate.instant("USER.IS_LOCAL_ADMIN"),
                userValue: this.user.isLocalAdmin
              },
              {
                userLabel: this.$translate.instant("USER.IS_ADMIN"),
                userValue: this.user.isAdmin
              },
              {
                userLabel: this.$translate.instant("USER.INVOICED_TIME"),
                userValue: this.user.invoicedTime
              },
              {
                userLabel: this.$translate.instant("USER.PROJECT_VISIBILITY_FROM_D365"),
                userValue: this.user.projectVisibilityFromD365
              },
              {
                userLabel: this.$translate.instant("USER.FORCE_POWER_USER"),
                userValue: this.user.forcePowerUser
              }
            ];

            this.userOfferCalcData = [
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_CLIENT_DATA_ACCESS"),
                userValue: this.user.calcClientDataAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_TEMPLATES_ACCESS"),
                userValue: this.user.calcTemplatesAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_TEMPLATES_EDIT_ACCESS"),
                userValue: this.user.calcTemplatesEditAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_OFFER_BUILDER_ACCESS"),
                userValue: this.user.calcOfferBuilderAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_GLOBAL_BIDS_ACCESS"),
                userValue: this.user.calcGlobalBidsAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_PG_VIEW_ACCESS"),
                userValue: this.user.calcPgViewAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_PG_EDIT_ACCESS"),
                userValue: this.user.calcPgEditAccess
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_DIRECT_LOG_IN"),
                userValue: this.user.directOClogin
              },
              {
                userLabel: this.$translate.instant("USER_OFFER_CALC.CALC_GLOBAL_TENDER_MANAGER"),
                userValue: this.user.calcGlobalTenderManager
              }
            ];

            if(this.userAdmin.isLocalAdmin){
              this.availableRoles = success[0].data.availableRoles.filter( role => role != "GlobalManager");
              this.userData.splice(10);
              this.userData.splice(7, 2);
              this.userData.splice(3, 1);

              this.userOfferCalcData.splice(4, 1);
            } else {
              this.availableRoles = success[0].data.availableRoles;
            }
            if (this.is360FeatureFlag && !this.userAdmin.isLocalAdmin) {
              this.userData.splice(9,0,
                {
                  userLabel: this.$translate.instant("USER.CAN_ACCESS360_VIEW"),
                  userValue: this.user.canAccess360View
                }
              );
            }

            if(!this.is360FeatureFlag) {
              const indexOf360 = this.userData.findIndex(d => d.userLabel == this.$translate.instant("USER.CAN_ACCESS360_VIEW"));
              this.userData.splice(indexOf360, 1);
              delete this.editUserData.canAccess360View;
            }

            if (this.isFlexiFeatureFlag && !this.userAdmin.isLocalAdmin) {
              this.userData.splice(10,0,
                {
                  userLabel: this.$translate.instant("USER.CAN_ACCESS_FLEXITIME"),
                  userValue: this.user.canAccessFlexitime
                }
              );
            }

            if(!this.isFlexiFeatureFlag) {
              const indexOfFlexi = this.userData.findIndex(d => d.userLabel == this.$translate.instant("USER.CAN_ACCESS_FLEXITIME"));
              if (indexOfFlexi !== -1) {
                this.userData.splice(indexOfFlexi, 1);
              }
              delete this.editUserData.canAccessFlexitime;
            }

            if(!this.isD365FeatureFlag) {
              const indexOfD365 = this.userData.findIndex(d => d.userLabel == this.$translate.instant("USER.PROJECT_VISIBILITY_FROM_D365"));
              this.userData.splice(indexOfD365, 1);
              delete this.editUserData.projectVisibilityFromD365;
            }

            if(this.user.role === "Employee") {
              this.userData.push(
                {
                  userLabel: this.$translate.instant("USER.RESTRICTED_CLIENT_ACCESS"),
                  userValue: this.user.restrictedClientAccess
                }
              );
            }

            this.userSelect = {
              role: this.availableRoles
            };

            var tempRole = this.userSelect.role[1];
            this.userSelect.role[1] = this.userSelect.role[2];
            this.userSelect.role[2] = tempRole;

            let localCountryName = success[2].data.country.name;
            function localSitesTop(a, b) {
              return (b.country === localCountryName) - (a.country === localCountryName);
            }

            this.positionSelect = {
              seniorityLevel: {
                valueToAdd: "id",
                valueToShow: "name",
                values: success[0].data.availableSeniorityLevels.map(level => ({id: level, name: this.$translate.instant(`USER.${level}`)}))
              },
              // seniorityLevel: success[0].data.availableSeniorityLevels,
              type: ["Worknorm", "Hourly", "Long Term Leave"],
              siteId: {
                valueToAdd: "id",
                valueToShow: "name",
                values: [].concat(this.userAdmin.isLocalAdmin ? success[0].data.availableSites.filter( site => site.name != "Iterators HQ").sort(localSitesTop) : success[0].data.availableSites).sort(localSitesTop)
              }
            };

            this.rates = success[0].data.rates;
            this.rates && this.rates.forEach((e, i) => {
              const profitCenter = success[0].data.availableProfitCenters.find(s => s.id == e.profitCenterId);
              this.rates[i].profitCenterName = profitCenter.name;
            });
            var tempRates = [];
            this.sites = success[2].data.sites;
            this.profitCenters = success[2].data.profitCenters;
            this.rates && this.profitCenters.forEach(s => {
              tempRates = tempRates.concat(this.rates.filter(r => r.profitCenterId == s.id));
            });

            this.isFlexibleWorknormFF = this.featureFlags.indexOf("FlexibleWorknormManagement") > -1;
            if(this.isFlexibleWorknormFF) {
              this.positionFields = configs.positionFieldsFlexibleWorknormFF;

              this.positionWeekDays = configs.positionWeekDays;

              this.positionExtraColspan = {
                mon: 7
              };

              this.dialogCardWidth = "wider";

              this.positionDialogCardWeekTable = configs.positionDialogCardWeekTable;

              this.positionData  =  configs.positionDataFlexibleWorknormFF;
            }
            this.rates = tempRates;
            this.rates = this.sortRates(this.rates);
            this.rates && this.rates.forEach((e, i) => {
              const profitCenter = success[0].data.availableProfitCenters.find(s => s.id == e.profitCenterId);
              this.rates[i].profitCenterName = `${profitCenter.code} - ${profitCenter.name}`;
            });

            this.sideBarConfig = {
              "country": this.$routeParams.name,
              "team": success[1].data.team,
              "users": angular.fromJson(localStorage.getItem("roedl-admin-users"))
            };
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  sortRates(rates) {
    var finalRates = [];

    var levels = ["L01", "L02", "L03", "L04", "L05", "L06", "L07", "L08", "L09", "L10"];

    finalRates.sort(function(a, b) {
      return new Date(a.validFrom) - new Date(b.validFrom);
    });
    for(var i in levels) {
      finalRates = finalRates.concat(rates.filter(r => r.seniorityLevel == levels[i]));
    }

    var tempRates = [];
    var profitCentersName = [];
    this.profitCenters.forEach(s => profitCentersName.push(s.name));
    profitCentersName = profitCentersName.sort();
    profitCentersName.forEach(s => {
      tempRates = tempRates.concat(finalRates.filter(r => r.profitCenterName == s));
    });

    return tempRates;
  }

  checkInputsFunc(isEmployee) {
    let restrictedClientAccess = {
      type: "checkbox",
      isNotRequired: true,
    };
    if(isEmployee.key === "role" && isEmployee.value === "Employee") {
      this.editUserData = {...this.editUserData, restrictedClientAccess: restrictedClientAccess};
      this.editUserValues.restrictedClientAccess = this.user.restrictedClientAccess;
    }
    else if(isEmployee.key === "role") {
      delete this.editUserData.restrictedClientAccess; this.editUserValues.restrictedClientAccess = false;
    }
  }

  startEditingUser() {
    this.editUserValues = angular.fromJson(angular.toJson(this.user));
    this.editUserProcess = true;
  }

  startEditingUserOCAccess() {
    this.getDirectLogInDisabledInfo();
    this.editUserOCAccessValues = angular.fromJson(angular.toJson(this.user));
    this.editUserOCAccessData.directOClogin.editionDisabled = this.isDirectLogInDisabled;
    this.editUserOCAccessProcess = true;
  }

  getDirectLogInDisabledInfo() {
    const isDirectLogInDisabled = this.userOfferCalcData && this.userOfferCalcData.find(data => data.userValue) ? false : true;
    this.isDirectLogInDisabled = isDirectLogInDisabled;
  }

  updateUser(user) {
    if (this.state == 'loading')
      return;

    if (this.userAdmin.isLocalAdmin) {
      delete user.isAdmin;
      delete user.isIntegrationAdmin;
      delete user.isLocalAdmin;
      delete user.canEditAccepted;
      delete user.canUpdateRates;
      delete user.canViewRates;
      delete user.calcGlobalBidsAccess;
      delete user.canAccess360View;
      delete user.canAccessFlexitime;
    }

    this.state = 'loading';

    if(user.restrictedClientAccess) {this.listAllowedClientsId = [];} //this is important line ! when we change flag then all clients are not allowed - then we need this line

    this.Admin.updateUser(user.id, user).then(
      () => {
        this.editUserProcess = false;
        this.editUserOCAccessProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startAddingPosition() {
    this.addPositionValues = null;
    this.addPositionValues = {
      "mon": 0,
      "tue": 0,
      "wed": 0,
      "thu": 0,
      "fri": 0,
      "sat": 0,
      "sun": 0
    };
    this.addPositionProcess = true;
  }

  sendRequestForUpdateClientAccess(tab, allowed, id) {
    this.Admin.updateRestrictedClients(this.$routeParams.userId, {clientIds: tab}).then(() => {
      this.clientRestrictedData.map( client => {
        if(client.id === id) {
          let newData = client;
          newData.isAllowed = allowed;
          return newData;
        }
      });
    }).catch(err => {
        this.state = err;
    });
  }

  startEditingAccess(client) {
     if(this.listAllowedClientsId.indexOf(client.id)<0) {
       this.listAllowedClientsId.push(client.id);
       this.sendRequestForUpdateClientAccess(this.listAllowedClientsId, true, client.id);
     }
     else {
      let tab = this.listAllowedClientsId.filter( id=> {
        return id !== client.id;
      });
      this.listAllowedClientsId = tab;
      this.sendRequestForUpdateClientAccess(tab, false, client.id);
     }
  }

  addPosition(originalPosition) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    let position = angular.copy(originalPosition);
    if(!this.isFlexibleWorknormFF){
      position.mon = position.standardWorkingHours;
      position.tue = position.standardWorkingHours;
      position.wed = position.standardWorkingHours;
      position.thu = position.standardWorkingHours;
      position.fri = position.standardWorkingHours;
      position.sat = 0;
      position.sun = 0;
    }
    this.setWorknormsInPosition(position);
    const positionToPost = this.preparePositionToPost(position);

    this.Admin.addPosition(this.$routeParams.userId, positionToPost).then(
      () => {
        this.addPositionProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingPosition(position) {
    if(position.type  === "LongTermLeave") {
      position.type = "Long Term Leave";
    }
    this.editPositionProcess = true;
    this.editPositionValues = angular.fromJson(angular.toJson(position));
    if(!this.isFlexibleWorknormFF) {
     this.editPositionValues.standardWorkingHours = this.editPositionValues.mon;
    }
  }

  updatePosition(originalPosition) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    let position = angular.copy(originalPosition);
    if(!this.isFlexibleWorknormFF){
      position.mon = position.standardWorkingHours;
      position.tue = position.standardWorkingHours;
      position.wed = position.standardWorkingHours;
      position.thu = position.standardWorkingHours;
      position.fri = position.standardWorkingHours;
      position.sat = 0;
      position.sun = 0;
    }
    this.setWorknormsInPosition(position);
    const positionToPost = this.preparePositionToPost(position);

    this.Admin.updatePosition(this.$routeParams.userId, position.id, positionToPost).then(
      () => {
        this.editPositionProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  setWorknormsInPosition(position) {
    position.worknorms = [
      parseFloat(position.mon),
      parseFloat(position.tue),
      parseFloat(position.wed),
      parseFloat(position.thu),
      parseFloat(position.fri),
      parseFloat(position.sat),
      parseFloat(position.sun)
    ];
    delete position.mon;
    delete position.tue;
    delete position.wed;
    delete position.thu;
    delete position.fri;
    delete position.sat;
    delete position.sun;
  }

  preparePositionToPost(position){
    const positionToPost = position;
    positionToPost.worknorms = positionToPost.worknorms.map((x) => {
      return isNaN(x) ? 0 : x;
    });

    if(positionToPost.type === this.$translate.instant("POSITION.WORKNORM"))
      positionToPost.type = "Worknorm";
    if(positionToPost.type === this.$translate.instant("POSITION.HOURLYNORM"))
      positionToPost.type = "Hourly";
    if(positionToPost.type === this.$translate.instant("POSITION.LONGTERMLEAVE"))
      positionToPost.type = "LongTermLeave";
    return positionToPost;
  }

  changeUser() {
    this.Auth.getUserToken( this.user.id ).then(
      (token) => {
        this.Auth.setupLogin(token.data);
        const tokenToGetRefreshToken = angular.fromJson(localStorage.getItem("ngStorage-roedl-session")).token;
        this.Auth.getRefreshToken(tokenToGetRefreshToken).then((refreshToken) => {
          this.Auth.setupRefreshToken(refreshToken);
          window.location = '/clients';
        });
      },
      (error) => {this.state = error;}
    );
  }

  resendPasswordEmail() {
    this.Admin.resendPasswordEmail(this.user.id).catch((error) => this.state = error);
  }

  copyPasswordLink() {
    return location.origin + '/password-reset/' + this.mailToken;
  }

  chooseSubscriptionFunc() {
    this.chooseSubscription = true;
  }

  startAddingSubscription() {
    this.chooseSubscription = false;
    this.subscriptionValues = {
      language: 'en',
      currency: 'Local',
      longTermReportTwelveMonths: false
    };
    this.subscriptionType = 'profitability';
    this.subscriptionData = this.profitabilitySubscriptionData;
    this.addSubscriptionProcess = true;
  }

  startAddingOvertimeSubscription() {
    this.subscriptionSelect.orderBy = {
      valueToAdd: "id",
      valueToShow: "name",
      values: Object.keys(this.overtimeSubscriptionOrder).map(key => ({id: key, name: this.overtimeSubscriptionOrder[key]}))
    };
    this.chooseSubscription = false;
    this.subscriptionValues = {
      language: 'en',
      teamRows: "10",
      employeeRows: "10",
      orderBy: "CumulatedOvertime"
    };
    this.subscriptionType = 'overtime';
    this.subscriptionData = this.overtimeSubscriptionData;
    this.addSubscriptionProcess = true;
  }

  startAddingOvertimeRequestAlertSubscription() {
    this.subscriptionValues = {
      language: 'en',
    };
    this.subscriptionType = 'overtimeRequestsAlert';
    this.subscriptionData = configs.overtimeRequestsAlertData;
    this.subscriptionSelect = {
      teamId: {
        valueToAdd: "id",
        valueToShow: "name",
        values: [{id: null, name: null}, ...this.subordinateTeams.filter(team => team.active)]
      },
    };
    this.chooseSubscription = false;
    this.addSubscriptionProcess = true;
  }

  prepareSubscriptionData(values) {
    let data = {};
    const tables = [];

    Object.entries(values).forEach(([key, value]) => {
      if (value === true && key !== "longTermReportTwelveMonths" && key !== "overtimeSubscription" && key !== "profitabilitySubscription")
        tables.push(key.charAt(0).toUpperCase() + key.slice(1));
      else if (this.teamColumnsWithThreshold.includes(key) && value)
        data[key] = moment.duration(value);
      else if (this.employeeColumnsWithThreshold.includes(key) && value)
        data[key] = moment.duration(value);
      else if (key.includes('Rows') || key === 'sendAtMonthDay')
        data[key] = parseInt(value);
      else if (key === 'orderBy')
        data[key] = value.split(" ").join("");
      else
        data[key] = value;
    });

    data = {
      ...data,
      userId: this.$routeParams.userId,
      tables: tables
    };

    return data;
  }

  createSubscription(values) {
    const valuesForRequest = angular.copy(values);
    this.state = 'loading';

    if (this.subscriptionType === 'overtime') {
      if (!valuesForRequest.employee) {
        delete valuesForRequest.employeeRows;
        this.employeeColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }

      if (!valuesForRequest.team) {
        delete valuesForRequest.teamRows;
        this.teamColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }
    }

    const data = this.subscriptionType === 'overtimeRequestsAlert' ? {...valuesForRequest, userId: this.$routeParams.userId} : this.prepareSubscriptionData(valuesForRequest);
    let request;
    switch (this.subscriptionType) {
      case 'overtime':
        request = this.Admin.createUserOvertimeSubscription(data);
        break;
      case 'profitability':
        request = this.Admin.createUserProfitabilitySubscription(data);
        break;
      case 'overtimeRequestsAlert':
        if (data.allTeams === false) delete data.allTeams;
        if (!data.teamId) delete data.teamId;
        request = this.Admin.createUserOvertimeRequestsSubscription(data);
        break;
      default:
        this.Notes.postNote({type: "error", error: "Unknown subscription type"});
        return;
    }

    request.then(
      () => {
        this.addSubscriptionProcess = false;
        this.editSubscriptionProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  updateSubscription(values) {
    const valuesForRequest = angular.copy(values);
    this.state = 'loading';

    if (this.subscriptionType === 'overtime') {
      if (!valuesForRequest.employee) {
        delete valuesForRequest.employeeRows;
        this.employeeColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }

      if (!valuesForRequest.team) {
        delete valuesForRequest.teamRows;
        this.teamColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }
    }

    const data = this.subscriptionType === `overtimeRequestsAlert` ? valuesForRequest : this.prepareSubscriptionData(valuesForRequest);
    let request;
    switch (this.subscriptionType) {
      case 'overtime':
        request = this.Admin.updateUserOvertimeSubscription(valuesForRequest.subscriptionId, data);
        break;
      case 'profitability':
        request = this.Admin.updateUserProfitabilitySubscription(valuesForRequest.subscriptionId, data);
        break;
      case 'overtimeRequestsAlert':
        if (valuesForRequest.allTeams === false) delete valuesForRequest.allTeams;
        request = this.Admin.updateUserOvertimeRequestsSubscription(valuesForRequest.subscriptionId, data);
        break;
      default:
        this.Notes.postNote({type: "error", error: "Unknown subscription type"});
        return;
    }

    request.then(
      () => {
        this.addSubscriptionProcess = false;
        this.editSubscriptionProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingSubscription(values) {
    this.subscriptionType = values.tables
      ? values.tables.some(key => ['Team', 'Employee'].includes(key)) ? 'overtime' : 'profitability'
      : 'overtimeRequestsAlert';
    switch (this.subscriptionType) {
      case `overtime`:
        this.subscriptionData = this.overtimeSubscriptionData;
        this.subscriptionSelect.orderBy = {
          valueToAdd: "id",
          valueToShow: "name",
          values: Object.keys(this.overtimeSubscriptionOrder).map(key => ({id: key, name: this.overtimeSubscriptionOrder[key]}))
        };
        break;
      case `profitability`:
        this.subscriptionData = this.profitabilitySubscriptionData;
        break;
      case `overtimeRequestsAlert`:
        this.subscriptionData = this.overtimeRequestsSubscriptionData;
        this.subscriptionSelect = {
          teamId: {
            valueToAdd: "id",
            valueToShow: "name",
            values: [{id: null, name: null}, ...this.subordinateTeams.filter(team => team.active)]
          },
        };
        break;
      default:
        this.Notes.postNote({type: "error", error: "Unknown subscription type"});
        return;
    }

    this.subscriptionValues = {
      ...values,
      subscriptionId: values.id,
    };

    if (!this.subscriptionType === 'overetimeRequestsAlert') {
      this.subscriptionValues.sendAtMonthDay = values.sendAtMonthDay.toString();
    }

    this.editSubscriptionProcess = true;
  }

  startDeletingSubscription(values) {
    this.subscriptionType = values.tables
      ? values.tables.some(key => ['Team', 'Employee'].includes(key)) ? 'overtime' : 'profitability'
      : 'overtimeRequestsAlert';
    switch (this.subscriptionType) {
      case `overtime`:
        this.subscriptionData = this.overtimeSubscriptionData;
        break;
      case `profitability`:
        this.subscriptionData = this.profitabilitySubscriptionData;
        break;
      case `overtimeRequestsAlert`:
        this.subscriptionData = this.overtimeRequestsSubscriptionData;
        this.subscriptionSelect.teamId = values.teamId && values.team;
        break;
      default:
        this.Notes.postNote({type: "error", error: "Unknown subscription type"});
        return;
    }

    this.subscriptionSelect.orderBy = this.overtimeSubscriptionOrder[values.orderBy];

    this.subscriptionValues = {
      ...values,
      subscriptionId: values.id
    };

    if (!this.subscriptionType === 'overetimeRequestsAlert') {
      this.subscriptionValues.sendAtMonthDay = values.sendAtMonthDay.toString();
    }

    this.deleteSubscriptionProcess = true;
  }

  deleteSubscription(values) {
    this.state = 'loading';
    const request = values.teamId || values.allTeams
      ? this.Admin.deleteUserOvertimeRequestsSubscription(values.subscriptionId)
      : values.team
      ? this.Admin.deleteUserOvertimeSubscription(values.subscriptionId)
      : this.Admin.deleteUserProfitabilitySubscription(values.subscriptionId);

    request.then(
      () => {
        this.deleteSubscriptionProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  formInvalid(values) {
    if (
      this.subscriptionType === 'profitability'
      && (values.profitability || values.hourlyRate || values.duration || values.overtime)
      && values.sendAtMonthDay
      && values.sendAtMonthDay.length > 0
    )
      return false;
    else if (
      this.subscriptionType === 'overtime'
      && values.sendAtMonthDay
      && values.sendAtMonthDay.length > 0
      && Object.keys(values).every(value => !value.includes('ThresholdError'))
      && (values.team || values.employee)
      && (!values.team || this.teamColumnsWithThreshold.some(key => values[key]))
      && (!values.employee || this.employeeColumnsWithThreshold.some(key => values[key]))
    )
      return false;
    else if (
      this.subscriptionType === 'overtimeRequestsAlert'
      && (
        (values.allTeams && !values.teamId)
        || (!values.allTeams && values.teamId)
      )
    ) {
        return false;
      }
    else
      return true;
  }

  startSendingSubscription(values) {
    this.sendingSubscriptionProcess = true;
    this.subscriptionValues = {
      ...values,
      subscriptionId: values.id
    };
  }

  sendSubscriptionManually(values) {
    this.state = 'loading';
    const request =
      values.tables && (values.tables.includes('Team') || values.tables.includes('Employee'))
      ? this.Admin.sendOvertimeSubscriptionManually(values.subscriptionId)
      : values.legalAlert
      ? this.Admin.sendLegalRuleAlert(values.subscriptionId)
      : values.team
      ? this.Admin.sendOvertimeRequestsSubscriptionManually(values.subscriptionId)
      : this.Admin.sendSubscriptionManually(values.subscriptionId);

    request.then(
      () => {
        this.sendingSubscriptionProcess = false;
        this.state = 'loaded';
        this.Notes.postNote({
          type: 'success',
          message: 'Subscription has been sent. It may take a few minutes for the email to arrive.'
        });
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: 'error', error: error});
      }
    );
  }

  startAddingLegalRulesAlert() {
    this.chooseSubscription = false;
    this.addLegalRuleAlertModalLanguage = 'EN';
    this.addLegalRuleAlertModal = true;
  }

  addLegalRuleAlert() {
    this.state = 'loading';

    const data = {
      userId: this.user.id,
      language: this.addLegalRuleAlertModalLanguage
    };

    this.Admin.createUserLegalRuleAlert(data).then(
      () => {
        this.state = 'loaded';
        this.addLegalRuleAlertModal = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  changeAlertLanguage(values) {
    this.changeLegalRuleAlertLanguageModal = true;
    this.changeLegalRuleAlertLanguageValue = values;
  }

  changeLegalRuleAlertLanguage() {
    this.state = 'loading';
    const language = this.changeLegalRuleAlertLanguageValue.language === 'en' ? 'DE' : 'EN';

    this.Admin.updateUserLegalRuleAlert(this.changeLegalRuleAlertLanguageValue.id, {language: language}).then(
      () => {
        this.state = 'loaded';
        this.changeLegalRuleAlertLanguageModal = false;
        this.changeLegalRuleAlertLanguageValue = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingAlert(values) {
    this.deleteAlertModal = true;
    this.deleteAlertModalValues = values;
  }

  deleteAlert() {
    this.state = 'loading';

    this.Admin.deleteUserLegalRuleAlert(this.deleteAlertModalValues.id).then(
      () => {
        this.state = 'loaded';
        this.deleteAlertModal = false;
        this.deleteAlertModalValues = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  toggleSubordinateTeam(team) {
    this.state = 'loading';

    if (team.overwrite)
      this.removeSubordinateTeamOverwite(team);
    else {
      const data = {
        teamId: team.id,
        operation: team.active ? "Remove" : "Add"
      };

      this.Admin.overwriteSubordinateTeams(this.user.id, data).then(
        () => this.refreshSubordinateTeams(),
        (error) => {
          this.state = 'loaded';
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
  }

  removeSubordinateTeamOverwite(team) {
    this.Admin.removeSubordinateTeamOverwrite(this.user.id, team.overwrite.id).then(
      () => this.refreshSubordinateTeams(),
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  refreshSubordinateTeams() {
    const promises = [
      this.Admin.getUserSubordinateTeams(this.$routeParams.userId),
      this.Admin.getUserSubordinateTeamsOverwrites(this.$routeParams.userId)
    ];

    this.$q.all(promises).then(
      (success) => {
        this.subordinateTeams = this.subordinateTeams
          .filter(team => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? team.id !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true)
          .map(team => ({
            ...team,
            active: success[0].data.subordinateTeams.some(subordinateTeam => subordinateTeam.id === team.id),
            main: team.id === this.user.teamId,
            overwrite: success[1].data.subordinateTeamOverwrites.find(teamOverwrites => teamOverwrites.teamId === team.id)
          }))
          .sort((teamA, teamB) => teamA.name.localeCompare(teamB.name))
          .sort((teamA, teamB) => teamB.main - teamA.main);

        this.state = 'loaded';
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
